.search {
  display: flex;
  flex: 1 1 240px;
  min-width: 0;
}

/* Visually hidden, still read out: the placeholder is what the eye needs. */
.label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.input {
  width: 100%;
  min-height: 48px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 16px;
}
